'use client'

import { useState } from 'react'
import Link from 'next/link'
import { Button, Input, Label } from '@repo/ui'
import { requestPasswordReset } from './actions'

export function ForgotPasswordForm({ initialEmail }: { initialEmail: string }) {
  const [email, setEmail] = useState(initialEmail)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [sentMessage, setSentMessage] = useState('')

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    setLoading(true)
    setError('')
    try {
      const result = await requestPasswordReset(email)
      if (result.success) setSentMessage(result.message)
      else setError(result.error)
    } catch {
      setError('İstek gönderilemedi. Yeniden deneyin.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="space-y-4">
      {sentMessage ? (
        <p role="status" className="rounded-lg border border-emerald-200 bg-emerald-50 px-3 py-2 text-sm text-emerald-800 dark:border-emerald-800 dark:bg-emerald-950/50 dark:text-emerald-200">
          {sentMessage}
        </p>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="reset-email">E-posta</Label>
            <Input
              id="reset-email"
              type="email"
              placeholder="E-posta"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
            />
          </div>
          {error && <p role="alert" className="text-sm text-destructive">{error}</p>}
          <Button type="submit" className="w-full" disabled={loading}>
            {loading ? 'Gönderiliyor...' : 'Sıfırlama bağlantısı gönder'}
          </Button>
        </form>
      )}
      <div className="text-center">
        <Link href="/login" className="text-xs text-muted-foreground hover:text-foreground underline underline-offset-2">
          Girişe dön
        </Link>
      </div>
    </div>
  )
}
